/**
 * Variant Media Filter
 * Filters product gallery slides and thumbs based on selected variant title.
 *
 * Rules:
 * 1. Media with empty alt (data-media-alt or alt="") -> always visible
 * 2. Media with alt text -> visible when an option value in variant title equals alt (case-insensitive)
 */

(function () {
  'use strict';

  var style = document.createElement('style');
  style.textContent = [
    '[data-product-single-media-thumbs] .swiper-slide.vmf-hidden,',
    '[data-product-single-media-thumbs] .swiper-slide[data-vmf-hidden] {',
    '  display: none !important;',
    '  width: 0 !important;',
    '  height: 0 !important;',
    '  min-width: 0 !important;',
    '  min-height: 0 !important;',
    '  padding: 0 !important;',
    '  margin: 0 !important;',
    '  overflow: hidden !important;',
    '  pointer-events: none !important;',
    '  opacity: 0 !important;',
    '}'
  ].join('\n');
  document.head.appendChild(style);

  var VariantMediaFilter = {

    galleryEl: null,
    mediaItems: [],

    init: function () {
      var self = this;
      self.galleryEl = document.querySelector('[data-product-single-media-group]');
      if (!self.galleryEl) return;

      self.waitForSwiper(function () {
        self.buildVariantCache();
        self.collectMediaItems();
        self.applyOnPageLoad();
        self.listenForVariantChange();
      });
    },

    waitForSwiper: function (callback) {
      var attempts = 0;
      var interval = setInterval(function () {
        attempts++;
        if (window.theme && window.theme.productGallerySwiper) {
          clearInterval(interval);
          callback();
        } else if (attempts > 60) {
          clearInterval(interval);
          callback();
        }
      }, 100);
    },

    buildVariantCache: function () {
      window.__vmfVariantCache = window.__vmfVariantCache || {};
      var cache = window.__vmfVariantCache;
      document.querySelectorAll('select[name="id"] option').forEach(function (opt) {
        var id = opt.value;
        var title = opt.getAttribute('data-variant-title') || opt.textContent.trim();
        if (id && title) cache[id] = title;
      });
      document.querySelectorAll('script[type="application/json"]').forEach(function (el) {
        try {
          var data = JSON.parse(el.textContent);
          var variants = data.variants || (Array.isArray(data) ? data : null);
          if (!variants) return;
          if (variants[0] && variants[0].media_type) return;
          variants.forEach(function (v) {
            if (v.id && v.title) cache[String(v.id)] = v.title;
          });
        } catch (e) {}
      });
    },

    getVariantTitleById: function (variantId) {
      variantId = String(variantId);
      var selectedEls = document.querySelectorAll('[data-selected-variant]');
      for (var s = 0; s < selectedEls.length; s++) {
        try {
          var v = JSON.parse(selectedEls[s].innerHTML);
          if (v && String(v.id) === variantId) return v.title;
        } catch (e) {}
      }
      var cache = window.__vmfVariantCache;
      if (cache && cache[variantId]) return cache[variantId];
      var option = document.querySelector('select[name="id"] option[value="' + variantId + '"]');
      if (option) return option.getAttribute('data-variant-title') || option.textContent.trim();
      return null;
    },

    getCurrentVariantTitle: function () {
      var variantId = new URLSearchParams(window.location.search).get('variant');
      if (!variantId) {
        var input = document.querySelector('product-info input[name="id"], product-info select[name="id"]');
        if (input && input.value) variantId = input.value;
      }
      if (variantId) return this.getVariantTitleById(variantId);

      var selectedEl = document.querySelector('variant-selects [data-selected-variant]');
      if (selectedEl) {
        try {
          var variant = JSON.parse(selectedEl.innerHTML);
          if (variant && variant.title) return variant.title;
        } catch (e) {}
      }
      return null;
    },

    getMediaAlt: function (el) {
      if (el && el.hasAttribute('data-media-alt')) {
        return (el.getAttribute('data-media-alt') || '').trim();
      }
      var img = el && el.querySelector('img');
      return ((img && img.getAttribute('alt')) || '').trim();
    },

    isEmptyAlt: function (altText) {
      return (altText || '').trim() === '';
    },

    getVariantOptionValues: function (variantTitleLower) {
      if (!variantTitleLower) return [];
      return variantTitleLower.split(/\s*\/\s*/).map(function (value) {
        return value.trim();
      }).filter(Boolean);
    },

    altMatchesVariant: function (altText, variantTitleLower) {
      if (this.isEmptyAlt(altText)) return true;
      if (!variantTitleLower) return false;

      var altLower = altText.trim().toLowerCase();
      var options = this.getVariantOptionValues(variantTitleLower);

      for (var i = 0; i < options.length; i++) {
        if (options[i] === altLower) return true;
      }

      return variantTitleLower === altLower;
    },

    isVisibleForVariant: function (altText, variantTitleLower) {
      return this.altMatchesVariant(altText, variantTitleLower);
    },

    collectMediaItems: function () {
      var self = this;
      self.mediaItems = [];

      var mainSliderEl = self.galleryEl.querySelector('[data-product-single-media-slider]');
      if (!mainSliderEl) return;

      var slides = mainSliderEl.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');
      slides.forEach(function (slide) {
        var mediaId = slide.getAttribute('data-id');
        if (!mediaId) return;

        var thumbEl = self.galleryEl.querySelector(
          '[data-product-single-media-thumbs] .swiper-slide[data-id="' + mediaId + '"]'
        );

        var slideAlt = self.getMediaAlt(slide);
        var thumbAlt = thumbEl ? self.getMediaAlt(thumbEl) : slideAlt;

        self.mediaItems.push({
          mediaId: mediaId,
          slideEl: slide,
          thumbEl: thumbEl || null,
          altText: slideAlt,
          thumbAltText: thumbAlt
        });
      });
    },

    applyFilter: function (variantTitleLower) {
      var self = this;
      var visibleMediaIds = {};
      var targetMediaId = null;
      var firstVisibleId = null;

      self.mediaItems.forEach(function (item) {
        var visible =
          self.altMatchesVariant(item.altText, variantTitleLower) ||
          self.altMatchesVariant(item.thumbAltText, variantTitleLower);

        if (visible) {
          visibleMediaIds[item.mediaId] = true;
          if (!firstVisibleId) firstVisibleId = item.mediaId;
          if (
            !targetMediaId &&
            !self.isEmptyAlt(item.altText) &&
            self.altMatchesVariant(item.altText, variantTitleLower)
          ) {
            targetMediaId = item.mediaId;
          }
        }
        self.setThumbVisible(item.thumbEl, visible);
      });

      if (!targetMediaId) targetMediaId = firstVisibleId;
      self.rebuildSwiper(visibleMediaIds, targetMediaId);
      self.updateThumbs(visibleMediaIds, targetMediaId, variantTitleLower);
    },

    setThumbVisible: function (thumbEl, visible) {
      if (!thumbEl) return;
      if (visible) {
        thumbEl.style.display = '';
        thumbEl.classList.remove('vmf-hidden');
        thumbEl.removeAttribute('data-vmf-hidden');
      } else {
        thumbEl.style.display = 'none';
        thumbEl.classList.add('vmf-hidden');
        thumbEl.setAttribute('data-vmf-hidden', '1');
      }
    },

    updateThumbs: function (visibleMediaIds, targetMediaId, variantTitleLower) {
      var self = this;
      var thumbsSliderEl = self.galleryEl.querySelector('[data-product-single-media-thumbs]');
      var thumbsSwiper = window.theme.productThumbsSwiper;
      if (!thumbsSliderEl) return;

      var thumbSlides = thumbsSliderEl.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');
      var targetThumbIndex = -1;
      var firstVisibleIndex = -1;

      thumbSlides.forEach(function (thumb, index) {
        var mediaId = thumb.getAttribute('data-id');
        var visible = mediaId
          ? !!visibleMediaIds[mediaId]
          : self.isVisibleForVariant(self.getMediaAlt(thumb), variantTitleLower);

        self.setThumbVisible(thumb, visible);

        if (visible) {
          if (firstVisibleIndex === -1) firstVisibleIndex = index;
          if (targetMediaId && mediaId === targetMediaId) targetThumbIndex = index;
        }
      });

      var wrapper = thumbsSliderEl.querySelector('.swiper-wrapper');
      if (wrapper) {
        var visibleThumbs = [];
        var hiddenThumbs = [];
        wrapper.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').forEach(function (thumb) {
          if (thumb.getAttribute('data-vmf-hidden') === '1') hiddenThumbs.push(thumb);
          else visibleThumbs.push(thumb);
        });
        visibleThumbs.forEach(function (thumb) { wrapper.appendChild(thumb); });
        hiddenThumbs.forEach(function (thumb) { wrapper.appendChild(thumb); });

        targetThumbIndex = -1;
        firstVisibleIndex = -1;
        visibleThumbs.forEach(function (thumb, index) {
          if (firstVisibleIndex === -1) firstVisibleIndex = index;
          if (targetMediaId && thumb.getAttribute('data-id') === targetMediaId) targetThumbIndex = index;
        });
      }

      if (thumbsSwiper) {
        thumbsSwiper.update();
        var slideIndex = targetThumbIndex >= 0 ? targetThumbIndex : firstVisibleIndex;
        if (slideIndex >= 0) {
          thumbsSwiper.slideTo(slideIndex, 0);
        }
      }
    },

    rebuildSwiper: function (visibleMediaIds, targetMediaId) {
      var self = this;
      var mainSwiper = window.theme.productGallerySwiper;
      if (!mainSwiper) return;

      var mainSliderEl = self.galleryEl.querySelector('[data-product-single-media-slider]');
      if (!mainSliderEl) return;

      if (typeof mainSwiper.loopDestroy === 'function') {
        mainSwiper.loopDestroy();
      }

      var wrapper = mainSliderEl.querySelector('.swiper-wrapper');
      if (!wrapper) return;

      var originals = wrapper.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');
      originals.forEach(function (slide) {
        var mediaId = slide.getAttribute('data-id');
        if (visibleMediaIds[mediaId]) {
          slide.style.display = '';
          slide.removeAttribute('data-vmf-hidden');
        } else {
          slide.style.display = 'none';
          slide.setAttribute('data-vmf-hidden', '1');
        }
      });

      if (typeof mainSwiper.loopCreate === 'function') {
        mainSwiper.loopCreate();
      }

      mainSwiper.update();

      if (targetMediaId) {
        var slides = mainSwiper.slides;
        for (var i = 0; i < slides.length; i++) {
          if (
            slides[i].getAttribute('data-id') === targetMediaId &&
            !slides[i].classList.contains('swiper-slide-duplicate')
          ) {
            var realIndex = parseInt(slides[i].getAttribute('data-swiper-slide-index'), 10);
            if (!isNaN(realIndex)) {
              mainSwiper.slideToLoop(realIndex, 400);
            } else {
              mainSwiper.slideTo(i, 400);
            }
            return;
          }
        }
      }

      mainSwiper.slideTo(0, 0);
    },

    applyOnPageLoad: function () {
      var self = this;
      var hasVariantInUrl = !!new URLSearchParams(window.location.search).get('variant');
      var variantTitle = this.getCurrentVariantTitle();
      var variantTitleLower = variantTitle ? variantTitle.toLowerCase().trim() : null;

      if (hasVariantInUrl) {
        self.applyFilter(variantTitleLower);
      } else {
        self.applyFilter(variantTitleLower);
        setTimeout(function () {
          var mainSwiper = window.theme.productGallerySwiper;
          var thumbsSwiper = window.theme.productThumbsSwiper;
          if (mainSwiper) mainSwiper.slideToLoop(0, 0, false);
          if (thumbsSwiper) thumbsSwiper.slideTo(0, 0, false);
        }, 50);
      }
    },

    listenForVariantChange: function () {
      var self = this;

      if (!window.theme || !window.theme.PUB_SUB_EVENTS || typeof subscribe !== 'function') {
        setTimeout(function () { self.listenForVariantChange(); }, 200);
        return;
      }

      subscribe(theme.PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        self.collectMediaItems();
        if (!variant || !variant.title) {
          self.applyOnPageLoad();
          return;
        }
        self.applyFilter(variant.title.toLowerCase().trim());
      });
    }
  };

  function boot() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        VariantMediaFilter.init();
      });
    } else {
      VariantMediaFilter.init();
    }

    document.addEventListener('shopify:section:load', function () {
      setTimeout(function () { VariantMediaFilter.init(); }, 400);
    });
  }

  boot();

})();
